import { Eyebrow, Reveal } from "@/components/site/Motion";

export default function LogoGrid({ eyebrow, title, intro, items, testid }) {
  if (!items?.length) return null;
  return (
    <section data-testid={testid} className="border-b border-ash">
      <div className="mx-auto max-w-[1440px] px-5 py-20 md:px-10 md:py-28">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h2 className="mt-8 max-w-3xl font-serif text-4xl font-medium leading-tight tracking-tight md:text-6xl">{title}</h2>
          {intro && <p className="mt-6 max-w-2xl text-base leading-relaxed text-obsidian/70">{intro}</p>}
        </Reveal>
        <div className="mt-14 grid grid-cols-2 border-l border-t border-ash sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
          {items.map((l, i) => (
            <Reveal key={l.id} delay={Math.min(i, 11) * 0.03} className="group flex h-28 items-center justify-center border-b border-r border-ash bg-paper p-6 transition-colors duration-300 hover:bg-white md:h-32">
              <img
                src={l.image}
                alt={l.name || "Client logo"}
                loading="lazy"
                className="h-full w-auto max-w-full object-contain grayscale opacity-75 transition-[filter,opacity] duration-500 group-hover:grayscale-0 group-hover:opacity-100"
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
